import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Landmark, Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("Password minimal 6 karakter"); return; }
    if (password !== confirm) { setError("Konfirmasi password tidak cocok"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password berhasil direset. Silakan masuk.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-xl brand-gradient flex items-center justify-center">
            <Landmark className="h-5 w-5 text-emerald-300" />
          </div>
          <p className="font-bold text-brand" style={{ fontFamily: "Outfit" }}>EXTRA TRUSS FINANCE</p>
        </div>
        <h1 className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>Reset Password</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Masukkan password baru Anda.</p>
        {!token && <p className="text-sm text-red-600 mb-4">Token tidak valid. Minta tautan baru.</p>}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="password">Password Baru</Label>
            <Input id="password" type="password" data-testid="reset-password-input" value={password}
              onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="confirm">Konfirmasi Password</Label>
            <Input id="confirm" type="password" data-testid="reset-confirm-input" value={confirm}
              onChange={(e) => setConfirm(e.target.value)} required className="mt-1.5" />
          </div>
          {error && <p data-testid="reset-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</p>}
          <Button type="submit" data-testid="reset-submit-btn" disabled={loading || !token} className="w-full bg-brand hover:bg-emerald-800 h-11">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset Password"}
          </Button>
        </form>
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-brand hover:underline mt-6">
          <ArrowLeft className="h-4 w-4" /> Kembali ke halaman masuk
        </Link>
      </div>
    </div>
  );
}
